import React, { useContext, useReducer, useEffect, useState } from 'react';
import visitorReducer from '../../Reducers/AuthReducer/VisitorReducer';
import { parseCookies } from 'nookies';
import {
  AUTH_VISITOR_USER_FAILED,
  AUTH_VISITOR_USER_SUCCESS,
} from '../../Helpers/Constant';
import { IVisitorAuthContext } from '../../Types/VisitorAuthTypes';
import axiosInstance from '../../Helpers/Fetcher/axios';

const initialState: IVisitorAuthContext = {
  visitorUser: {
    visitor_id: null,
    visitor_first_name: null,
    visitor_last_name: null,
    visitor_email: null,
    visitor_phone: null,
    visitor_photo: null,
    token: null,
    visitor_no: null,
    type: null,
    visitor_address: null,
    visitor_designation: null,
    visitor_status: null,
    visitor_organization: null,
  },
};
const VisitorContext = React.createContext(initialState);
const VisitorAuthContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(visitorReducer, initialState);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const toab_visitor_token = localStorage.getItem('toab_visitor_token');
      if (toab_visitor_token) {
        setIsLoading(true);
        try {
          // const { payload } = await jose.jwtVerify(
          //   toab_fair,
          //   new TextEncoder().encode('FaTO5b$eCzw!Ukw8^d*UUf*JABbeIrR')
          // );

          const { data } = await axiosInstance.get(`/api/auth/visitor/profile`);
          dispatch({
            type: AUTH_VISITOR_USER_SUCCESS,
            payload: { ...data?.data, token: toab_visitor_token },
          });
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          dispatch({ type: AUTH_VISITOR_USER_FAILED });
        }
      } else {
        setIsLoading(false);
        dispatch({ type: AUTH_VISITOR_USER_FAILED });
      }
    })();
  }, []);

  return (
    <VisitorContext.Provider
      value={{ ...state, dispatch, isLoading, setIsLoading }}
    >
      {children}
    </VisitorContext.Provider>
  );
};

const VisitorAuthContext = () => {
  const context = useContext(VisitorContext);
  return context as IVisitorAuthContext;
};

export { VisitorAuthContextProvider, VisitorAuthContext };
